import { Breakpoints, CTA } from '@volkswagen-onehub/components-core';
import React from 'react';
import { OfertasContext } from '../context/ofertas-context';
import { actionRedirect } from '../helpers/ofertas-helper';
import { useOfertasTracker } from '../helpers/use-ofertas-tracker';
import { CarlineWithOfertas, Oferta } from '../services/ofertas-service/models/ofertas';

export const RedirectCTAs = ({
	oferta,
	carline,
	copy,
	isMobile,
	emphasis,
	trackingRef,
	formTrigger,
}: {
	oferta: Oferta;
	carline: CarlineWithOfertas;
	copy: string;
	isMobile: boolean;
	emphasis: 'primary' | 'secondary';
	trackingRef?: string;
	formTrigger: string;
}) => {
	const { userInteractionService } = React.useContext(OfertasContext);
	const { trackOfertasButtonClick } = useOfertasTracker();

	const handleOnClick = () => {
		const contentId = trackingRef ? `${copy} - ${trackingRef}` : copy;
		const id = copy;
		trackOfertasButtonClick(contentId, oferta, carline, id);

		if (formTrigger === 'es-oneform-v2') {
			actionRedirect(
				userInteractionService,
				`es-oneform-v2-action--open_layer?formName=lead_venta-presupuesto&featureApp=esofertasv2&ofertaId=${oferta.id}&carline=${oferta.carline?.name}`,
			);
		} else {
			actionRedirect(
				userInteractionService,
				`es-oneform-v2-action--open_layer?formName=lead_venta-call_me&carline=${oferta.carline?.name}&ofertaId=${oferta.id}&featureApp=esofertasv2`,
			);
		}
	};

	return (
		<>
			<CTA
				data-testid="redirect-cta"
				tag="button"
				emphasis={emphasis}
				size={isMobile ? 'large' : 'small'}
				stretchContent={{
					[Breakpoints.default]: true,
					[Breakpoints.b560]: false,
				}}
				onClick={handleOnClick}
			>
				{copy}
			</CTA>
		</>
	);
};
